export default __webpack_public_path__ + "static/media/magze_brand_red_bg.d496c4e1.svg";